export default "//file.bilionpass.com/japandx-web/0.0.1/static/departure-icon.af71c6fb-3efbd8.svg";